// extracted by mini-css-extract-plugin
export default {"imgdiv":"_2049abe364 _25c8caff3e","img":"_1737171892 f8b3edb67a"};